export * from "./htmlElementTexture.pure";
